import { render, staticRenderFns } from "./SepaMandateDisplay.vue?vue&type=template&id=06860868&scoped=true&"
import script from "./SepaMandateDisplay.vue?vue&type=script&lang=js&"
export * from "./SepaMandateDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SepaMandateDisplay.vue?vue&type=style&index=0&id=06860868&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06860868",
  null
  
)

export default component.exports